import React from "react";
import { ActivityIcon, BookOpenCheckIcon } from "lucide-react";
import { images } from "../../data/landing";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
export function Hero() {
  return <header className="px-5 pb-14 pt-7 text-center sm:pt-10" data-id="element-161" data-mp="cu9rsfx2swqb">
      <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-162" data-mp="hvh0qiayg1yk">
        <div className="flex items-center gap-2" data-id="element-163" data-mp="mu0n2jtgnfrg">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-white" data-id="element-164" data-mp="mt9202xhp0ff">
            <ActivityIcon className="h-5 w-5" strokeWidth={2.5} aria-hidden="true" data-id="element-165" data-mp="qub20lz8dgig" />
          </span>
          <span className="font-serif text-xl font-extrabold text-navy" data-id="element-166" data-mp="vnniu9xo4j0n">
            Clinical Blueprint<sup className="text-xs" data-id="element-167" data-mp="10k43gu5nsf8z">™</sup>
          </span>
        </div>
        <span className="flex items-center gap-1.5 rounded-full border border-navy/10 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-brand" data-id="element-168" data-mp="15l1uzxck6ln5">
          <BookOpenCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-169" data-mp="1ahilgy78dc3e" />
          Diabetes Clinical Blueprint™
        </span>
      </div>

      <h1 className="mx-auto mt-7 max-w-4xl font-serif text-[2.4rem] font-black leading-[1.06] text-ink sm:text-6xl" data-id="element-170" data-mp="4o6mbng1j181">
        Find the next clinical question in diabetes care in{" "}
        <em className="text-brand" data-id="element-171" data-mp="3rtp6c45xsssj">under 2 minutes</em>
      </h1>
      <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-172" data-mp="3rv8ra82jfs0n">
        A practical clinical decision system by Dr. Henry Wells. Includes{" "}
        <strong className="text-ink" data-id="element-173" data-mp="ngimq4n4vsfj">6 practical volumes</strong>,{" "}
        <strong className="text-ink" data-id="element-174" data-mp="inz8r6kjava7">5 specialized clinical tools</strong> and a{" "}
        <strong className="text-ink" data-id="element-175" data-mp="emvx6w9irles">visual decision framework</strong> to organize consultations, treatment reviews and follow-up.
      </p>

      <img src={images.mockup} alt="Diabetes Clinical Blueprint: six volumes and five clinical tools" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-176" data-mp="1b5le447kkzn8" />

      <p className="mx-auto mt-2 max-w-xl text-base font-semibold text-navy" data-id="element-177" data-mp="30ldyt24r62mw">
        Stop searching through scattered references every time a clinical question arises.
      </p>

      <div className="mx-auto mt-6 max-w-xl" data-id="element-178" data-mp="2qw473ndtmlzb">
        <p className="mb-3 text-sm font-extrabold uppercase tracking-wide text-brand" data-id="element-179" data-mp="2qvcjozudnuk4">
          6 Volumes + 5 Specialized Clinical Tools + Instant Digital Access
        </p>
        <CtaButton id="hero-cta" label="Yes, I want Diabetes Clinical Blueprint" data-id="element-180" data-mp="2hv68jkm5j6o4" />
        <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-181" data-mp="2mu96kl3pscml">
          Instant Download · One-Time Payment of <strong className="text-ink" data-id="element-182" data-mp="27xrshm454jwc">$27</strong> · Lifetime Access to This Edition · 7-Day Money-Back Guarantee
        </p>
      </div>

      <Countdown data-id="element-183" data-mp="2cwuzvd7lf27h" />
    </header>;
}